import { TFunction } from 'i18next'

import { Option } from '@core/Constants/FieldOptionsConstants'

export const translateSelectOption = <T>(options: Option<T>[], t: TFunction): Option<T>[] => {
    return options.map((option) => {
        return {
            label: t(option.label),
            value: option.value,
        }
    })
}
